import { ElectricalAspectService } from './electrical-aspect.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ELECTRICAL_ASPECT_TYPE, ElectricalAspect } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class ElectricalAspectResolverBase implements Resolve<ElectricalAspect> {

  constructor(protected service: ElectricalAspectService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ElectricalAspect> {
    const key: number = ELECTRICAL_ASPECT_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



